import styled from 'styled-components';

export const ErrorText = styled.p`
    color: ${({ theme }) => theme.error};
    font-size: 1rem;
    width: 100%;
    word-break: break-word;
    margin-top: 0.3rem !important;
    margin-bottom: 0;
`;
